module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "id": "ded",
      "title": "Dedication"
    }
  }, [_c('p', {
    staticClass: "fm_head"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_v",
      "title": "v"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780063075771_Contents#rded"
    }
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded_pb_1"
  }, [_vm._v("F"), _c('span', {
    staticClass: "make_smallcaps"
  }, [_vm._v("OR")])]), _vm._v(" "), _c('p', {
    staticClass: "ded_pb_1"
  }, [_vm._v("H"), _c('span', {
    staticClass: "make_smallcaps"
  }, [_vm._v("AROLD")]), _vm._v(" R"), _c('span', {
    staticClass: "make_smallcaps"
  }, [_vm._v("OSS")])]), _vm._v(" "), _c('p', {
    staticClass: "ded_pb_1"
  }, [_c('i', [_vm._v("with increasing admiration,")])]), _vm._v(" "), _c('p', {
    staticClass: "ded_pb_1"
  }, [_c('i', [_vm._v("wonder and affection")])]), _vm._v(" "), _c('div', {
    staticClass: "fig_40"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f00ii-01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9031ba90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780063075771_Dedication.vue
// module id = 63
// module chunks = 0